import { SCHEMA_CTX } from '../constants';

// Transforms review statistics into an AggregateRating object for schema.org format
const aggregateRatingObject = (reviews) => {
  const ratingValue = reviews?.Includes?.Products?.store?.FilteredReviewStatistics?.AverageOverallRating;
  const reviewCount = reviews?.TotalResults;
  const baseObject = {
    '@type': 'AggregateRating',
  };

  if (!ratingValue || !reviewCount) return {};
  if (ratingValue) baseObject.ratingValue = ratingValue;
  if (reviewCount) baseObject.reviewCount = reviewCount;

  return {
    aggregateRating: baseObject
  };
};

// Transforms review data into structured Review objects for schema.org format
const reviewsObject = (reviews) => {
  const reviewsResults = reviews?.Results || [];

  if (!reviewsResults.length) return {};

  const object = reviewsResults.map((review) => ({
    '@type': 'Review',
    reviewRating: {
      '@type': 'Rating',
      ratingValue: review?.Rating || 0,
      bestRating: '5',
    },
    author: {
      '@type': 'Person',
      name: review.UserNickname || '',
    },
    headline: review.Title || '',
    reviewBody: review.ReviewText || '',
  }));

  return { reviews: object };
};

/**
 * Builds a ProductGroup schema object for structured data.
 * @param {Object} params - The parameters object
 * @param {Object} params.product - The product object containing details and identifiers
 * @param {Object} params.reviews - The reviews object containing rating and review data
 * @param {string} params.groupName - The name of the product group
 * @returns {Object} A ProductGroup schema object with context, type, and nested properties
 */
export const getProductGroupSchema = ({ product, reviews, groupName }) => {
  return {
    '@context': SCHEMA_CTX,
    '@type': 'ProductGroup',
    name: groupName,
    description: product?.details?.description || '',
    brand: {
      '@type': 'Brand',
      name: product?.identifiers?.brandName || ''
    },
    ...aggregateRatingObject(reviews),
    productGroupID: product?.identifiers?.parentId || '',
    ...reviewsObject(reviews),
  };
};
